import ArcButton from "../../../components/arc/ArcButton";
import {useNavigate} from "react-router-dom";

export interface DashboardNoDataProps {
  message?: string;
  link?: DashboardNoDataLinkProps;
  className?: string;
}

export interface DashboardNoDataLinkProps {
  text: string;
  to: string;
}

export default function DashboardNoData(props: Readonly<DashboardNoDataProps>) {
  const navigate = useNavigate();

  function handleClickBtn() {
    if (props.link) {
      navigate(props.link.to);
    }
  }

  return (
    <div className="n-overlay type2 show">
      <div className={`n-ol-inner1 ${props.className ?? ''}`}>
        <p className="icon">
          <i className="xi-message-o"></i>
        </p>
        <p className="txt">{props.message ?? '조회된 데이터가 없습니다.'}</p>
        {props.link && (
          <ArcButton
            color="btn-style1"
            style={{marginTop: '0.5rem'}}
            text={props.link.text}
            title={props.link.text}
            isExportAnchorTag={false}
            onClick={handleClickBtn}
          />
        )}
      </div>
    </div>
  );
}